module.exports = __webpack_public_path__ + "static/img/DSC_0091.16ebcc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_0091.jpg
// module id = +cBw
// module chunks = 0